import {
  collection,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "@/lib/firebase";

export type LaunchSplashStatus = "active" | "inactive";

export interface LaunchSplashImage {
  id: string;
  url: string;
  status: LaunchSplashStatus;
  altText?: string | null;
  routePath?: string | null;
  width?: number | null;
  height?: number | null;
  createdAt?: Date;
  updatedAt?: Date;
}

const COLLECTION = "launchSplashImages";

const mapDocToLaunchSplash = (docSnap: any): LaunchSplashImage => {
  const data = docSnap.data() || {};
  return {
    id: docSnap.id,
    url: data.url,
    status: data.status || "inactive",
    altText: data.altText ?? null,
    routePath: data.routePath ?? null,
    width: data.width ?? null,
    height: data.height ?? null,
    createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : undefined,
    updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : undefined,
  };
};

export const fetchActiveLaunchSplashImage = async (): Promise<LaunchSplashImage | null> => {
  const splashRef = collection(db, COLLECTION);
  const splashQuery = query(
    splashRef,
    where("status", "==", "active"),
    orderBy("createdAt", "desc"),
    limit(1)
  );

  const snapshot = await getDocs(splashQuery);
  if (snapshot.empty) return null;

  return mapDocToLaunchSplash(snapshot.docs[0]);
};

export const subscribeToActiveLaunchSplashImage = (
  callback: (image: LaunchSplashImage | null) => void
): (() => void) => {
  const splashRef = collection(db, COLLECTION);
  const splashQuery = query(
    splashRef,
    where("status", "==", "active"),
    orderBy("createdAt", "desc"),
    limit(1)
  );

  return onSnapshot(
    splashQuery,
    (snapshot) => {
      if (snapshot.empty) {
        callback(null);
      } else {
        callback(mapDocToLaunchSplash(snapshot.docs[0]));
      }
    },
    (error) => {
      console.error("Error subscribing to launch splash image:", error);
      callback(null);
    }
  );
};
